import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, XIcon, MapPinIcon } from 'lucide-react';
import { POP_CLIENTS } from '../data/landing';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = () => {
      setVisible(true);
      timeout = setTimeout(() => {
        setVisible(false);
        timeout = setTimeout(() => {
          setIndex(i => (i + 1) % POP_CLIENTS.length);
          cycle();
        }, 4000); // pausa entre pop-ups
      }, 5000); // tiempo visible
    };
    const start = setTimeout(cycle, 3500); // primer disparo
    return () => {
      clearTimeout(start);
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dismissed]);
  if (dismissed) return null;
  const client = POP_CLIENTS[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)]" data-id="element-204" data-mp="163mpzd5zo90u">
      <AnimatePresence data-id="element-205" data-mp="1151wdwl8snld">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto flex w-80 max-w-full items-center gap-3 rounded-2xl border border-neutral-200 bg-white p-3 shadow-2xl" data-id="element-206" data-mp="1fw241ze60dgg">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600" data-id="element-207" data-mp="x6vv3436b07u">
              <CheckCircleIcon className="h-6 w-6" data-id="element-208" data-mp="s8aqksgw1udl" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-209" data-mp="28iwmkqrf92ra">
              <p className="text-sm font-bold leading-tight text-neutral-900" data-id="element-210" data-mp="23ld6rmf2shx8">
                {client.nombre} acaba de comprar
              </p>
              <p className="truncate text-xs text-neutral-600" data-id="element-211" data-mp="2anrx3abujik2">
                El MegaPack de 250 recetas 🎉
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] text-neutral-400" data-id="element-212" data-mp="2fpqzagvuo9ff">
                <MapPinIcon className="h-3 w-3" data-id="element-213" data-mp="2knip95cxplgz" /> {client.ciudad} · {client.tiempo}
              </p>
            </div>
            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="shrink-0 rounded-full p-1 text-neutral-400 transition-colors hover:bg-neutral-100 hover:text-neutral-700" data-id="element-214" data-mp="2pjhl1e0le5rf">
              <XIcon className="h-4 w-4" data-id="element-215" data-mp="21w9gwzewh2qz" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}